import {
  GetSystemParameterKeysRequest,
  GetSystemParameterKeysRequestToJSON,
  HTTPQuery,
  SystemParameterKey,
  SystemParameterKeyFromJSON
} from '@/api'
import * as runtime from '../runtime'

/**
 * no description
 */
export class SystemParameterKeyApi extends runtime.BaseAPI {
  /**
   * システムパラメーターキーの一覧を取得する
   * システムパラメーターキー取得
   */
  async getSystemParameterKeys(
    request?: GetSystemParameterKeysRequest
  ): Promise<SystemParameterKey[]> {
    let queryParameters: HTTPQuery | undefined

    if (request) {
      queryParameters = Object.fromEntries(
        Object.entries(GetSystemParameterKeysRequestToJSON(request)).filter(
          value => value[1] !== undefined
        )
      ) as HTTPQuery
    }

    const response = await this.requestGet(
      `/system-parameter-keys`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemParameterKeyFromJSON)
    ).value()
  }

  /**
   * 入力条件により、システムパラメーターキーを取得する
   * システムパラメーターキー取得
   */
  async getSystemParameterKey(id: number): Promise<SystemParameterKey> {
    const response = await this.requestGet(`/system-parameter-keys/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemParameterKeyFromJSON(jsonValue)
    ).value()
  }
}
